import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchRenewTasks } from '../renew-tasks/renewTasksSlice'
import useFilteredRenewTasks from '../renew-tasks/useFilteredRenewTasks'

// Variable pour suivre si la requête a déjà été effectuée
let dataFetchInitiated = false

/**
 * Hook personnalisé pour accéder au contexte des tâches de renouvellement
 * Ce hook initialise également le chargement des données si nécessaire
 */
export const useRenewTasks = () => {
  const dispatch = useDispatch()
  const allTasks = useSelector(state => state.renewTasks?.items || [])
  const loading = useSelector(state => state.renewTasks?.loadingStatus?.fetchList || false)
  
  // TODO mettre les paramètres par défaut côté backend dans la table Settings
  //      et que ces paramètres soit fetch par l'application pour les garder en cache et les réutiliser ici
  // Paramètres par défaut
  const daysWindow = 30
  const maxTasksPerType = 100

  // Effectuer une seule requête API pour récupérer toutes les tâches
  useEffect(() => {
    if (!dataFetchInitiated && allTasks.length === 0) {
      dataFetchInitiated = true
      dispatch(fetchRenewTasks({
        status: 'pending',
        upcoming_days: daysWindow
      }))
    }
  }, [dispatch, allTasks.length])

  // Utiliser le hook useFilteredRenewTasks pour chaque type de tâche
  const assuranceTasks = useFilteredRenewTasks({
    taskType: 'assurance',
    daysWindow: 0,
    maxTasks: maxTasksPerType,
    statuses: ['pending', 'completed']
  })

  const diagnosticTasks = useFilteredRenewTasks({
    taskType: 'diagnostic',
    daysWindow: 0,
    maxTasks: maxTasksPerType,
    statuses: ['pending', 'completed']
  })

  const entretienTasks = useFilteredRenewTasks({
    taskType: 'entretien',
    daysWindow,
    maxTasks: maxTasksPerType,
    statuses: ['pending', 'completed']
  })

  const facturationTasks = useFilteredRenewTasks({
    taskType: 'facturation',
    daysWindow,
    maxTasks: maxTasksPerType,
    statuses: ['pending', 'completed']
  })

  // Créer la valeur du contexte à la volée
  const value = {
    loading,
    tasksByType: {
      assurance: {
        tasks: assuranceTasks.tasks,
        typeConfig: assuranceTasks.typeConfig
      },
      diagnostic: {
        tasks: diagnosticTasks.tasks,
        typeConfig: diagnosticTasks.typeConfig
      },
      entretien: {
        tasks: entretienTasks.tasks,
        typeConfig: entretienTasks.typeConfig
      },
      facturation: {
        tasks: facturationTasks.tasks,
        typeConfig: facturationTasks.typeConfig
      }
    }
  }

  return value
}

// Pas besoin d'exporter un Provider, car nous utilisons un hook qui initialise les données
export default useRenewTasks
